import React from "react";
import {notification} from "antd";
import {CloseOutlined} from "@ant-design/icons";
import {PALETTE} from "./palette";
import {showBrowserNotification} from "./helper";
import {NotifyProps, NType} from "./interface";
import {resolveI18n} from "./notifierI18n";
import {wrapText} from "../../../helpers/stringHelper";

type Defaults = {
    duration: number;
    maxWidth: number;
    maxLineWidth: number;
    placement: "top" | "topLeft" | "topRight" | "bottomLeft" | "bottomRight" | "bottom";
};

let defaults: Defaults = {
    duration: 4.5,
    maxWidth: 560,
    maxLineWidth: 46,
    placement: "top",
};

export const configureNotifier = (d: Partial<Defaults>) => {
    defaults = { ...defaults, ...d };
};


export const notify = async (opts: NotifyProps) => {
    const type: NType = opts.type ?? "success";
    const palette = PALETTE[type];

    const baseTitle = opts.title ?? (type === "error" ? "Bilinmeyen Hata" : "İşlem Başarılı...");
    const baseMessage = opts.message ?? "...";

    const { title, message } = await resolveI18n(baseTitle, baseMessage, opts.i18n);

    const hasExplicitBreaks = message.includes("\r\n");
    const canCharWrap = opts.i18n?.notTranslate === true;
    const lines = canCharWrap
        ? wrapText(message, opts.maxLineWidth ?? defaults.maxLineWidth)
        : hasExplicitBreaks
            ? message.split("\r\n")
            : [message];

    if (opts.showBrowserNotification) {
        showBrowserNotification(title, message);
    }

    notification.open({
        key: opts.key,
        className: `mino-notification mino-${type}`,
        icon: null,
        duration: opts.duration ?? defaults.duration,
        closeIcon: <CloseOutlined style={{ color: "rgba(0,0,0,.45)" }} />,
        message: (
            <div className="mino-head">
                <span className="mino-icon-badge" aria-hidden>{palette.icon}</span>
                <span className="mino-title" aria-live="polite">{title}</span>
            </div>
        ),
        description: (
            <div className="mino-desc">
                {lines.map((line, i) => <p key={i} className="mino-line">{line}</p>)}
            </div>
        ),
        style: { maxWidth: opts.maxWidth ?? defaults.maxWidth },
        placement: opts.placement ?? defaults.placement,
    });
};
